


export const GlobalVariables = {
    // Firebase Auth
    firebaseAuth: {
        internalError: 'auth/internal-error',
    },
    // Bright Adipose Tissue (BAT) Scan process
    batscan: {
        visualizationMinHU: -150,
        visualizationMaxHU: 200,
        cursorColor: [255, 0, 0],
        classes: [
            { id: 1, name: 'Muscle', color: [255, 0, 0] }, // Red
            { id: 2, name: 'SAT', color: [0, 255, 255] },  // Cyan
            { id: 3, name: 'VAT', color: [255, 255, 0] },  // Yellow
        ]
    }
}